import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/index'

import './registerServiceWorker'
import './plugins/axios'

import './plugins/mixins/validation'
import './plugins/vue-sweetalert2'
import './plugins/vue-offline'
import './plugins/vue-apex-charts'
import './plugins/mixins/user'
import './scss/global.scss'
import vuetify from './plugins/vuetify'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Sentry.init({
  dsn: 'https://bfc62a54397f4ff0bb206b695b2d89a8@sentry.io/1778789',
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

import Default from "./layouts/Default.vue"
import Guest from "./layouts/Guest.vue"




Vue.component("default-layout", Default);
Vue.component("guest-layout", Guest);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
